import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import App from './App'
import { AuthProvider } from './lib/auth'
import { queryClient } from './lib/queryClient'
import { ThemeProvider } from './components/theme-provider'
import { initSentry, Sentry } from './lib/sentry'
import './styles/tailwind.css'
import './styles/demo-brand.css'
import { aplicarTemaTenant } from './lib/brand'

aplicarTemaTenant()

initSentry()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('No #root element')

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<DefaultErrorFallback />}>
      <ThemeProvider defaultTheme="light">
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
        </QueryClientProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)

function DefaultErrorFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 12,
        padding: 24,
        textAlign: 'center',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <h1 style={{ fontSize: 22, fontWeight: 600, margin: 0 }}>
        Algo salió mal
      </h1>
      <p
        style={{
          fontSize: 14,
          color: 'var(--n-600)',
          maxWidth: 420,
          margin: 0,
        }}
      >
        Estamos investigando. Si el problema persiste, recargá la página o
        contactá al equipo.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 20px',
          borderRadius: 8,
          border: '1px solid var(--n-300)',
          background: 'transparent',
          fontSize: 14,
          cursor: 'pointer',
        }}
      >
        Recargar
      </button>
    </div>
  )
}
